module.exports = __webpack_public_path__ + "static/media/logo2.aca0e293.svg";